export default __webpack_public_path__ + "static/media/Gloves of the Reanimator.190088b0.jpg";